<script setup lang="ts">
import { useHead } from '@unhead/vue';
import RequestInfo from '@/components/forms/RequestInfo.vue';
import Banner from '@/components/shared/Banner.vue';
import hoursIcon from '@/images/icons/hours.png';
import phoneIcon from '@/images/icons/phone.png';

useHead({
  title: 'Request Information | Student Assurance Services',
  meta: [
    {
      name: 'description',
      content: 'Request additional information about student accident insurance programs.',
    },
  ],
});
</script>

<template>
  <Banner image="request-info" alt="Request information">
    <h1>Request<br />Information</h1>
  </Banner>
  <div class="container-sm px-30 py-48">
    <div class="grid grid-cols-1 gap-50 lg:-mr-40 lg:grid-cols-2 xl:-mr-80">
      <div class="flex flex-col gap-50">
        <p class="md:text-17 lg:pr-130">
          Please fill out the form to request additional information or to ask a question.
        </p>
        <p class="-mt-40">* Required fields</p>
        <div class="grid grid-cols-1 gap-20 sm:grid-cols-2">
          <div class="flex flex-col gap-10">
            <img class="w-30" :src="hoursIcon" alt="Hours" />
            <div class="text-17 font-medium uppercase">Hours of Operation</div>
            <p>8 a.m. - 4:30 p.m. (CST)<br />Monday - Friday</p>
          </div>
          <div class="flex flex-col gap-10">
            <img class="w-30" :src="phoneIcon" alt="Phone" />
            <div class="text-17 font-medium uppercase">Customer Service</div>
            <p>Toll Free: 1-800-328-2739<br />Fax: 651-439-0200</p>
          </div>
        </div>
        <p>Email to: <a href="mailto:info@sas-mn.com">info@sas-mn.com</a></p>
      </div>
      <RequestInfo />
    </div>
  </div>
</template>
